import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=6ac70246&scoped=true"
import script from "./InputMoney.vue?vue&type=script&lang=ts"
export * from "./InputMoney.vue?vue&type=script&lang=ts"
import style0 from "./InputMoney.vue?vue&type=style&index=0&id=6ac70246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac70246",
  null
  
)

export default component.exports